import { useEffect } from 'react';
import type { NetworkPointDetail } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useNetworkPointByUuid(uuid?: string) {
  const request = useManualNetworkPointByUuid();

  useEffect(() => {
    if (uuid) request.execute(uuid);
    // oxlint-disable-next-line exhaustive-deps
  }, [uuid]);

  return request;
}

export function useManualNetworkPointByUuid() {
  return useAxios(
    (axios, baseConfig, uuid: string) =>
      axios.request<NetworkPointDetail>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/networkPoints/by-uuid/${uuid}`,
      }),
    { neededOnPageLoad: false }
  );
}
